/* eslint class-methods-use-this: "off"  */

import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import _ from "underscore";

import RoundSpinner from "genericComponents/RoundSpinner";
import Input from "@exovera/input";
import vars from "@exovera/narrative-tracker-variables";

import {
	attemptLogIn,
	openForgotPasswordView,
	updateLoginEmail,
	updatePassword,
} from "actions/login.js";

class Login extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			focusEmail: false,
			focusPassword: false,
			emailError: false,
			passwordError: false,
		};
		this.validateForm = this.validateForm.bind(this);
	}
	componentDidMount() {
		this.setState({ focusEmail: true }); // Doesn't work in the contructor
		// console.log(this.props);
		// this.props.loader();
	}

	// just checking for empty fields
	validateForm() {
		const { props } = this;
		if (!props.validationInProgress && props.loginInputEmail && props.loginInputPassword) {
			this.setState({ emailError: false, passwordError: false });
			props.dispatch(
				attemptLogIn(props.loginInputEmail, props.loginInputPassword, props.lastProject)
			);
		} else if (!props.validationInProgress && !props.loginInputPassword && !props.loginInputEmail) {
			this.setState({ emailError: true, passwordError: true, focusEmail: true });
		} else if (!props.validationInProgress && !props.loginInputPassword) {
			this.setState({ passwordError: true, focusPassword: true });
		} else if (!props.validationInProgress && !props.loginInputEmail) {
			this.setState({ emailError: true, focusEmail: true });
		}
	}

	render() {
		const { props, state } = this;
		// console.log("Login", props.authState);
		const loginClass = classnames("login", { error: props.loginError });
		const emailErrorClass = classnames("login__error", { visible: state.emailError });
		const passwordErrorClass = classnames("login__error", { visible: state.passwordError });
		const buttonBoxClass = classnames("login__submit-box", { spinner: props.validationInProgress });

		return (
			<div className={loginClass}>
				<div className="login__box">
					<p className="login__top-error">{props.loginErrorText}</p>
					<h1 className="login__header">Sign In</h1>

					<div className="login__input-box">
						<label htmlFor="login-email" className="login__input-label">
							Email
						</label>
						<Input
							acceptBtnFunction={this.validateForm}
							focus={state.focusEmail} // can set focus by passing a prop
							label={false}
							id="login-email"
							// note: PropTypes.func, // appears below input. Expects a React component
							onChange={(value) => props.dispatch(updateLoginEmail(value))}
							placeholder=""
							// "dark", 'light', 'inline'. Themes show a box, none is inline. Add ' search' to any
							theme={"dark"}
							type="email"
							value={props.loginInputEmail}
						/>
						<p className={emailErrorClass}>Please enter your username or email address.</p>
					</div>

					<div className="login__input-box">
						<label htmlFor="login-email" className="login__input-label">
							Password
						</label>
						<div
							className="login__forgot-password"
							onClick={() => props.dispatch(openForgotPasswordView())}
						>
							Forgot password?
						</div>
						<Input
							acceptBtnFunction={this.validateForm}
							focus={state.focusPassword} // can set focus by passing a prop
							onFocus={this.props.loader} // does not dispatch
							label={false}
							id="login-password"
							// note: PropTypes.func, // appears below input. Expects a React component
							onChange={(value) => props.dispatch(updatePassword(value))}
							placeholder=""
							// "dark", 'light', 'inline'. Themes show a box, none is inline. Add ' search' to any
							theme={"dark"}
							type="password"
							value={props.loginInputPassword}
						/>
						<p className={passwordErrorClass}>Please enter your password.</p>
					</div>

					<div className={buttonBoxClass}>
						<div className="login__spinner">
							<RoundSpinner scale={0.6} color={vars.cerulean_2} />
						</div>

						<button type="submit" className="login__submit" onClick={this.validateForm}>
							<span className="login__submit--text">Sign In</span>
						</button>
					</div>
				</div>
			</div>
		);
	}
}

Login.propTypes = {
	dispatch: PropTypes.func.isRequired,
	validationInProgress: PropTypes.bool.isRequired,
	loginError: PropTypes.bool.isRequired,
	loginErrorText: PropTypes.string.isRequired,
	loginInputEmail: PropTypes.string.isRequired,
	loginInputPassword: PropTypes.string.isRequired,
};

export default Login;
